import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { CourseService } from 'src/app/services/course/course.service';
import { PackageService } from 'src/app/services/package/package.service';

@Component({
  selector: 'app-add-store',
  templateUrl: './add-store.component.html',
  styleUrls: ['./add-store.component.scss']
})
export class AddStoreComponent {
  storeForm!:FormGroup;
  public packageArr:any[]=[]
  constructor(
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private appService: AppService,
    public dialogRef: MatDialogRef<AddStoreComponent>,
    private packageService:PackageService,
    private courseService:CourseService
  ) {}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.storeForm=this.fb.group({
      'packageList':['',Validators.required]
    })
    this.getPackageListing()
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(
      this.storeForm,
      controlName,
      validationType
    );
  }
  onSubmit(){
   let obj={
    p_id:this.storeForm.get('packageList')?.value
   }
    // any changes made here make changes in reapply for package also
    this.courseService.addStore(obj).subscribe({
      next: (result: any) => {
        // this.isSpinnerLoading = false;
        if(result.status==200){
         this.appService.showToastMessage('success',result.msg);
         this.dialogRef.close({data_added:true})
        }
      },
      error: (error: any) => {
        // this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }
  getPackageListing(){
    let obj={
      st:0,
      r_p:10,      
      op_nd:'or',
      f_a:[],
      sh:''
    }
    this.packageService.getSellPackage(obj).subscribe({
      next: (result: any) => {
        if(result.status==200){
          this.packageArr = [];
         this.packageArr = result["data"];
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onCLick(item){}
}
